// extracted by mini-css-extract-plugin
module.exports = {"MasPageIcon":"IconSVG_MasPageIcon__xyw6a","FavoritosIcon":"IconSVG_FavoritosIcon__2L82H","BackIcon":"IconSVG_BackIcon__C2-TW","IconSVG":"IconSVG_IconSVG__1WyX8"};